import {
  ContentFieldType,
  contentFieldTypeFiltersGroups,
  contentFieldTypeGroups,
  ContentFieldTypeArray,
  ContentFieldTypeValue,
  PrimitiveType,
} from "./contentField.type";

function createTypeGuard<const T extends readonly string[]>(values: T) {
  return (value: unknown): value is T[number] => {
    return typeof value === "string" && values.includes(value as T[number]);
  };
}

export const primitiveTypeMap = new Map<ContentFieldTypeValue, PrimitiveType>(
  (
    Object.entries(contentFieldTypeGroups) as Array<
      [PrimitiveType, readonly ContentFieldTypeValue[]]
    >
  ).flatMap(([primitive, types]) =>
    types.map((type) => [type, primitive] as const),
  ),
);

export function getPrimitiveType(type: ContentFieldTypeValue): PrimitiveType {
  const primitive = primitiveTypeMap.get(type);
  if (!primitive) {
    throw new Error(`Tipo de campo desconhecido: ${type}`);
  }
  return primitive;
}
export const contentFieldTextTypes = contentFieldTypeGroups.string;
export type TextFieldType = (typeof contentFieldTextTypes)[number];
export const isTextFieldType = createTypeGuard(contentFieldTextTypes);

export const searchableContentFieldTypes =
  contentFieldTypeFiltersGroups.searchable;
export type SearchableContentFieldType =
  (typeof searchableContentFieldTypes)[number];
export const isSearchableContentFieldType = createTypeGuard(
  searchableContentFieldTypes,
);

export const contentFieldNumberTypes = contentFieldTypeGroups.number;
export type NumberFieldType = (typeof contentFieldNumberTypes)[number];
export const isNumberFieldType = createTypeGuard(contentFieldNumberTypes);

export const contentFieldBooleanTypes = contentFieldTypeGroups.boolean;
export type BooleanFieldType = (typeof contentFieldBooleanTypes)[number];
export const isBooleanFieldType = createTypeGuard(contentFieldBooleanTypes);

export const contentFieldDateTypes = contentFieldTypeGroups.date;
export type DateFieldType = (typeof contentFieldDateTypes)[number];
export const isDateFieldType = createTypeGuard(contentFieldDateTypes);

export const contentFieldImageTypes = contentFieldTypeGroups.image;
export type ImageFieldType = (typeof contentFieldImageTypes)[number];
export const isImageFieldType = createTypeGuard(contentFieldImageTypes);

export const contentFieldGalleryTypes = contentFieldTypeGroups.gallery;
export type GalleryFieldType = (typeof contentFieldGalleryTypes)[number];
export const isGalleryFieldType = createTypeGuard(contentFieldGalleryTypes);

export const filterableContentFieldTypes =
  contentFieldTypeFiltersGroups.filterable;
export type FilterableContentField =
  (typeof filterableContentFieldTypes)[number];
export const isFilterableContentField = createTypeGuard(
  filterableContentFieldTypes,
);

export const globalFilterFieldTypes =
  contentFieldTypeFiltersGroups.globalFilter;
export const globalFilterFieldTypesEnum = Object.fromEntries(
  globalFilterFieldTypes.map((type) => [type, type]),
) as Record<GlobalFilterFieldType, GlobalFilterFieldType>;
export type GlobalFilterFieldType = (typeof globalFilterFieldTypes)[number];
export const isGlobalFilterFieldType = createTypeGuard(globalFilterFieldTypes);

export const contentFieldArrayTypes = contentFieldTypeGroups.array;
export type ArrayFieldType = (typeof contentFieldArrayTypes)[number];
export const isArrayFieldType = createTypeGuard(contentFieldArrayTypes);

export const contentFieldArrayStringTypes = [
  ContentFieldType.ARRAY_STRING,
] as const satisfies ContentFieldTypeArray;
export type ArrayStringFieldType =
  (typeof contentFieldArrayStringTypes)[number];
export const isArrayStringFieldType = createTypeGuard(
  contentFieldArrayStringTypes,
);

export const contentFieldCompositeTypes = contentFieldTypeGroups.composite;
export type CompositeFieldType = (typeof contentFieldCompositeTypes)[number];
export const isCompositeFieldType = createTypeGuard(contentFieldCompositeTypes);

export const contentFieldRepeaterTypes = [
  ContentFieldType.REPEATER,
] as const satisfies ContentFieldTypeArray;
export type RepeaterFieldType = (typeof contentFieldRepeaterTypes)[number];
export const isRepeaterFieldType = createTypeGuard(contentFieldRepeaterTypes);

export const contentFieldPlansTypes = contentFieldTypeGroups.plans;
export type PlansFieldType = (typeof contentFieldPlansTypes)[number];
export const isPlansFieldType = createTypeGuard(contentFieldPlansTypes);
